export const PDFHeaderColumns = [
  { headerName: 'LRNO', exportHead: 'LRNO', field: 'LRNO', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'number', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew	',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNumberOld',
    exportHead: 'Sender MobileNumberOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNumberNew',
    exportHead: 'Sender MobileNumberNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'RecMobile NoOld',
    exportHead: 'RecMobile NoOld',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'RecMobile NoNew',
    exportHead: 'RecMobile NoNew',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'GST Amount Old',
    exportHead: 'GST Amount Old',
    field: 'ServiceTaxAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'GST Amount New',
    exportHead: 'GST Amount New',
    field: 'ServiceTaxAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsFormattedLRNO = [
  {
    headerName: 'Formatted LR Number',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'number', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew	',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'RecMobile Number Old',
    exportHead: 'RecMobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'RecMobile Number New',
    exportHead: 'RecMobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'GST Amount Old',
    exportHead: 'GST Amount Old',
    field: 'ServiceTaxAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'GST Amount New',
    exportHead: 'GST Amount New',
    field: 'ServiceTaxAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsForBoth = [
  { headerName: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'Formatted LR Number',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'number', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew	',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'RecMobile Number Old',
    exportHead: 'RecMobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'RecMobile Number New',
    exportHead: 'RecMobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'GST Amount Old',
    exportHead: 'GST Amount Old',
    field: 'ServiceTaxAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'GST Amount New',
    exportHead: 'GST Amount New',
    field: 'ServiceTaxAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsTwo = [
  { headerName: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'number', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew	',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver Mobile Number Old',
    exportHead: 'Receiver Mobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver Mobile Number New',
    exportHead: 'Receiver Mobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsFormattedLRNOTwo = [
  {
    headerName: 'Formatted LR Number',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'number', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew	',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver Mobile Number Old',
    exportHead: 'Receiver Mobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver Mobile Number New',
    exportHead: 'Receiver Mobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsForBothTwo = [
  { headerName: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'Formatted LR Number',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'number', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew	',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver Mobile Number Old',
    exportHead: 'Receiver Mobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver Mobile Number New',
    exportHead: 'Receiver Mobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
]
export const LrDetailsColumns = [
  { headerName: 'LRNO', exportHead: 'LRNO', field: 'LRNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'FormattedLR',
    exportHead: 'FormattedLR',
    field: 'FormattedLRNo',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'ManualLrNO',
    exportHead: 'ManualLrNO',
    field: 'ManualLRNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Book DateTime',
    exportHead: 'Book DateTime',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Pmt Type',
    exportHead: 'Pmt Type',
    field: 'PaymentTypeDet',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sender Name',
    exportHead: 'Sender Name',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Receiver Name',
    exportHead: 'Receiver Name',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'From City',
    exportHead: 'From City',
    field: 'FromCity',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  { headerName: 'To City', exportHead: 'To City', field: 'ToCity', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
]
